import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative bg-[#182940] pt-24 md:pt-28 overflow-hidden">
      <div className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16 lg:py-20">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12">
          <div className="flex-1 max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 border border-white/20 text-sm text-white/90 mb-6">
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-global-line text-sm"></i>
              </span>
              Independent &amp; Unbiased Guidance
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
              Dental Care Abroad — Done <span className="text-primary-400">Safely</span>
            </h1>
            <p className="text-base md:text-lg text-white/70 leading-relaxed mb-8">
              Thinking about dental treatment in Hungary, Poland, Turkey or Spain? Our free guide and destination quiz help you compare countries, spot red flags, and plan with confidence.
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mb-8">
              <Link
                to="/quiz"
                className="inline-flex items-center justify-center px-6 py-3 text-base font-medium rounded-md bg-primary-500 text-white hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                Find My Best Destination
                <span className="w-5 h-5 flex items-center justify-center ml-2">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
              <Link
                to="/checklist"
                className="inline-flex items-center justify-center px-6 py-3 text-base font-medium rounded-md border-2 border-white/30 text-white hover:bg-white/10 transition-colors whitespace-nowrap"
              >
                Get the Free Guide
                <span className="w-5 h-5 flex items-center justify-center ml-2">
                  <i className="ri-file-text-line"></i>
                </span>
              </Link>
            </div>
          </div>

          <div className="flex-1 max-w-md lg:max-w-lg">
            <img
              src="https://public.readdy.ai/ai/img_res/edited_1ce5a8a02283fbd6e40dabebb06b695d_b793df52.jpg"
              alt="Friendly dental advisor smiling confidently"
              width={700}
              height={360}
              className="w-full h-auto rounded-xl object-cover"
              loading="eager"
            />
          </div>
        </div>
      </div>
    </section>
  );
}